export default __webpack_public_path__ + "static/media/caloTokenCircle.2d0820ef.png";